// @flow
export default function toCamelCase(s: string): string {
  return s.replace(/[_.-](\w|$)/g, (_, x) => x.toUpperCase());
}
